import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2182d8cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "inputgroup" }
const _hoisted_3 = { class: "checkboxWarpper" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("选择并同意《用户协议》及《隐私协议》")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提交认证")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanField = _resolveComponent("VanField")!
  const _component_VanCheckbox = _resolveComponent("VanCheckbox")!
  const _component_VanButton = _resolveComponent("VanButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanImage, {
      src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/app/identify/name_top.png",
      width: "100%",
      height: "auto"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_VanField, {
        label: "真实姓名:",
        placeholder: "请输入用户名",
        modelValue: $setup.detail.username,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.detail.username) = $event)),
        border: false,
        "input-align": "left",
        required: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_VanField, {
        label: "身份证号:",
        placeholder: "请输入身份证号码",
        modelValue: $setup.detail.idcard,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.detail.idcard) = $event)),
        border: false,
        "input-align": "left",
        required: ""
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_VanCheckbox, {
        "checked-color": "#19be6b",
        modelValue: $setup.isCheck,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.isCheck) = $event)),
        style: {"margin":"10px auto"},
        shape: "square"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_VanButton, {
        size: "normal",
        type: "danger",
        style: {"margin":"20px 20px"},
        round: "",
        onClick: $setup.submit
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}